<!--
    ABRE OS LOTES DO ITEM PARA BAIXA DE ESTOQUE OU ENTRADA DE ESTOQUE

- lista lotes do item com quantidade em estoque disponível
- lista lotes do item para entrada em estoque por nota de entrada independente se há estoque disponível

-->

<script>
import { apiORDS, apiORDSpost, apiORDSdelete } from '../shared/api-functions'
import { SysVars } from '../main';
import { formatValue, formatDate } from '../shared/utils';
import Vue from 'vue';

export default {
  props: {
    entrada: { type: Boolean },
    somenteComQuantidade: { type: Boolean },
    coditem: { type: String },
    coditemgrade: { type: String },
    filial: { type: [String, Number] },
    obj: { type: Object }
  },

  components: {
    formatValue, formatDate
  },

  data() {
    return {
      metadata: this.$store.getters.getEntities.metadata,
      estoqueList: [],
      estoque: null,
      codqest: null,
    }
  },

  computed: {

    opcoesList: function () {
      let options = []
      //codigo adicionado para evitar erro de autocarregar valor default quando tem somente um registro na lista do select2
      options.push({ id: -1, text: 'selecione uma opção' })
      //end
      for (var x = 0; x < this.estoqueList.length; x++) {
        if (this.somenteComQuantidade && (!this.estoqueList[x].qt || this.estoqueList[x].qt < 0)) {
          continue;
        }
        let value = ''
        if (this.estoqueList[x].coddeposito)
          value += 'Depósito: ' + this.estoqueList[x].coddeposito
        if ((this.estoqueList[x].coluna) || (this.estoqueList[x].linha)) {
          value += (value ? ' / ' : ' ') + 'Grade: '
          if (this.estoqueList[x].linha)
            value += this.estoqueList[x].linha
          if (this.estoqueList[x].coluna)
            value += (this.estoqueList[x].linha ? ' ' : '') + this.estoqueList[x].coluna
        }
        if (this.estoqueList[x].lote)
          value += (value ? ' / ' : ' ') + 'Lote: ' + this.estoqueList[x].lote
        if (this.estoqueList[x].sublote)
          value += (value ? ' / ' : ' ') + 'Sub-lote: ' + this.estoqueList[x].sublote
        if (this.estoqueList[x].dtval)
          value += (value ? ' / ' : ' ') + 'Dt.Val.: ' + formatDate(this.estoqueList[x].dtval)
        if (this.estoqueList[x].qt)
          value += (value ? ' / ' : ' ') + 'Qtd.: ' + formatValue(this.estoqueList[x].qt, 2)

        options.push({ id: this.estoqueList[x].codqest, text: value })

      }
      return options
    },

  },

  methods: {

    loadData() {
      let self = this

      let url = this.$store.getters.urlOrds + 'estoque/lotes/item/' + this.coditem

      if (this.coditemgrade && this.coditemgrade !== '') {
        url = url + '/grade/' + this.coditemgrade
      }

      url = url + '/filial/' + this.filial
      if (this.entrada)
        url = url + '/todos'
      else
        url = url + '/disponivel'

      this.estoqueList = []

      apiORDS(url, null, true).then((result) => {
        self.estoqueList = result.items
        if (self.estoqueList.length == 0)
          self.$emit('semestoque')
      })
    },

  },

  watch: {
    codqest: function () {
      this.estoque = null
      let self = this
      let selected = this.estoqueList.filter(function (obj) {
        return obj.codqest == self.codqest
      })
      if (selected.length > 0) {
        this.estoque = selected[0]
        this.obj.codqest = this.estoque.codqest
        this.obj.lote = this.estoque.lote
        this.obj.sublote = this.estoque.sublote
        this.obj.coddeposito = this.estoque.coddeposito
        this.obj.loteforn = this.estoque.loteforn
        this.obj.dtval = this.estoque.dtval
        this.obj.dtfab = this.estoque.dtfab
        this.obj.linha = this.estoque.linha
        this.obj.coluna = this.estoque.coluna
        this.obj.coditemgrade = this.estoque.coditemgrade
        this.obj.selecionarLote = false
        this.$emit('select', this.estoque)
      } else {
        this.obj.codqest = null
        this.obj.lote = null
        this.obj.sublote = null
        this.obj.coddeposito = null
        this.obj.loteforn = null
        this.obj.dtval = null
        this.obj.dtfab = null
        this.obj.linha = null
        this.obj.coluna = null
        this.obj.coditemgrade = null
        this.obj.qt = null
      }
    }
  },

  mounted() {
    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })
  },

  created() {
    this.loadData()
  }



}

</script>

<template>
  <div class="col-12 px-0">
    <div class="row m-0">
      <form-field v-model="codqest" type="select2static" col="12" label="Selecione um lote"
        placeholder="Selecione um lote" :select-options="opcoesList"></form-field>
    </div>
  </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-estoque/estoque-selecionar-lote.vue